module.exports = __webpack_public_path__ + "img/6.5eb9d1f0.jpg";